import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import Icon from 'JS/components/Icon.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import { computed, ref } from 'vue';
import { ILocalStoreJson } from "JS/types/LocalStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'StoreSummaryMobile',
  props: {
    store: null
  },
  setup(__props: any) {

const props = __props as {
	store: ILocalStoreJson;
}



const isExpanded = ref(false);


const storeDetailsUrl = computed(() => {
	return props.store.urlAlias ? `/stores/${props.store.urlAlias}` : null;
});
const	storePhoneLink = computed(() => {
	return props.store && props.store.phone ? `tel:+1${props.store.phone.replace(/\D/g, '')}` : null;
});


return { __sfc: true,props, isExpanded, storeDetailsUrl, storePhoneLink, BButton, Icon, TransitionExpand }
}

})